import { useTranslation } from 'react-i18next';
import { Page } from '@/components';
import { useParams } from 'react-router-dom';
import { TermsAndConditionsDetailsPanel } from '@/views';

const useId = () => {
  const { id } = useParams<'id'>();
  return id!;
};

export function TermsAndConditionsDetailsPage() {
  const { t } = useTranslation();
  const title = t('termsAndConditions.title');
  const id = useId();

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/admin#terms-and-conditions">
          {t('termsAndConditions.title')}
        </Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card title={title} color="#814A93">
          <TermsAndConditionsDetailsPanel id={id} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
